<template>
  <responsive-modal v-model="visible" title="API do Facebook">
    <div class="product-facebook-pixel-modal">
      <a
        target="_blank"
        href="https://www.facebook.com/business/help/2041148702652965?id=818859032317965"
        class="integration-link"
      >
        Conheça a API de Conversões do Facebook
        <i class="ph ph-arrow-square-out" />
      </a>

      <snow-input
        id="form-domain"
        v-model="form.domain"
        :errors="errors.domain"
        label="Domínio do site"
      />
      <snow-input
        id="form-api_key"
        v-model="form.api_key"
        :errors="errors.api_key"
        label="Chave da API"
      />
      <snow-input
        id="form-ads_pixel_id"
        v-model="form.ads_pixel_id"
        :errors="errors.ads_pixel_id"
        label="ID do pixel"
      />

      <div class="snow-submit-buttons mt-3">
        <snow-button
          text="Salvar"
          size="lg"
          class="order-lg-1"
          :disabled="!isValid"
          @click="submit"
        />
        <snow-button
          text="Cancelar"
          size="lg"
          variant="gray"
          @click="visible = false"
        />
      </div>
    </div>
  </responsive-modal>
</template>

<script>
import { clearObject, formFields } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["product_id", "domain", "api_key", "ads_pixel_id"]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("product", ["product"]),
    isValid() {
      return this.form.domain && this.form.api_key && this.form.ads_pixel_id;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSuccess() {
      this.loading = false;
      this.$message.success("A integração foi salva!");
      this.$emit("update-list");
      this.clear();
      this.visible = false;
    },
    submit() {
      this.loading = true;

      let data = {
        ...this.form,
        product_id: this.product.id
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, clearObject(data))
        .then(this.onSuccess)
        .catch(error => {
          this.errors = error.response.data;
          let errorMsg = get(error, "response.data.message");
          this.$message.error(errorMsg ? errorMsg : "Erro ao salvar");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.product-facebook-pixel-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
